import { render, staticRenderFns } from "./DropdownButton.vue?vue&type=template&id=fc9934b4&scoped=true&"
import script from "./DropdownButton.vue?vue&type=script&lang=ts&"
export * from "./DropdownButton.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownButton.vue?vue&type=style&index=0&id=fc9934b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9934b4",
  null
  
)

export default component.exports